cb.define(function () {
  var AA_aa_userlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
	  var self = this;
	  let gridModel = viewmodel.getGridModel();
      gridModel.on('afterSetDataSource', function (data) {
		if (cb.rest.AppContext.user.customer)
		{
			viewmodel.get("btnVenSuitOrg").setVisible(false);
			viewmodel.get("btnVenSuitCust").setVisible(false); 			
		}
		else
		{
			viewmodel.get("btnVenSuitOrg").setVisible(true);
			if (cb.rest.AppContext.tenant.isOpenUdh==true)
			{viewmodel.get("btnVenSuitCust").setVisible(true); }
			else
			{viewmodel.get("btnVenSuitCust").setVisible(false); }
		}
      });
	  gridModel.on('beforeLoad',function(data)
	  {
		data.isDistinct = true;
	  });
      viewmodel.on('beforeEdit', function (args) {
         return self.checkorg(viewmodel,args);
      });
      viewmodel.on('beforeBatchdelete', function (args) {
        return self.checkorg(viewmodel,args);
      });
	  viewmodel.on('beforeDoService', function (args) {
        return self.checkorg(viewmodel,args);
      });
			//分配组织字段所在的隐藏的viewmodel
			var vensuitorgReferModel = new cb.models.ReferModel({
				cRefType: 'aa_orgtree'
			});
			viewmodel.addProperty('vensuitorg', vensuitorgReferModel);
			vensuitorgReferModel.setVisible(false);
			//分配组织的批量操作
			viewmodel.on('addvensuitorg', function(args) {
				vensuitorgReferModel.setCache('args', args);
				vensuitorgReferModel.browse(true);
			});
			//分配组织之前判断是否选择供应商
			vensuitorgReferModel.on('beforeBrowse', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择需要分配的供应商！', 'warning');
					return false;
				}
			});
			//分配客户字段所在的隐藏的viewmodel
			var vensuitcustReferModel = new cb.models.ReferModel({
				cRefType: 'aa_cust'
			});
			viewmodel.addProperty('vensuitcust', vensuitcustReferModel);
			vensuitcustReferModel.setVisible(false);
			//分配客户的批量操作
			viewmodel.on('addvensuitcust', function(args) {
				vensuitcustReferModel.setCache('args', args);
				vensuitcustReferModel.browse(true);
			});
			//分配客户之前判断是否选择供应商
			vensuitcustReferModel.on('beforeBrowse', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				if(selectedRows == undefined || selectedRows.length == 0) {
					cb.utils.alert('未选择需要分配的供应商！', 'warning');
					return false;
				}
			});
			vensuitorgReferModel.on('afterValueChange', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				var selectedorgId = data.value.id;
				var url = '/bill/batchDo?action=addvensuitorg';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});
				var datas = [];
				if(selectedorgId == undefined || selectedorgId.length == 0) {
					cb.utils.alert('未选择要分配的组织！', 'warning');
				} else {
					var length = selectedRows.length;
					for(var i = 0; i < length; i++) {

						datas.push({
							"vendororg": selectedRows[i]["id"],
							"org": selectedorgId,
						});
					}
					var params = {
						billnum: "aa_vendorlist",
						data: JSON.stringify(datas)
					}
					proxy.ensure(params, function(err, result) {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}
						debugger
						if(result) {
							var count = result.count;
							var sucessCount = result.sucessCount;
							var failCount = result.failCount;
							if(result.messages.length > 0) {
								var messages = result.messages;
								var vendors = '';
								var length = messages.length;
								for(var i = 0; i < length; i++) {
									vendors += messages[i];
									vendors += "、";
								}
								var vendors2 = vendors.substring(0, vendors.length -1);
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。 ' + vendors2 + '已分配此组织，此次操作未对其生效！', 'warning');
							} else {
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。', 'success');
							}

						}
						viewmodel.execute('refresh');
					});
				}
			});
			vensuitcustReferModel.on('afterValueChange', function(data) {
				var selectedRows = viewmodel.getGridModel().getSelectedRows();
				var selectedcustId = data.value.id;
				var url = '/bill/batchDo?action=addvensuitcust';
				var proxy = cb.rest.DynamicProxy.create({
					ensure: {
						url: url,
						method: 'POST'
					}
				});
				var datas = [];
				if(selectedcustId == undefined || selectedcustId.length == 0) {
					cb.utils.alert('未选择要分配的客户！', 'warning');
				} else {
					var length = selectedRows.length;
					for(var i = 0; i < length; i++) {

						datas.push({
							"vendorcustom": selectedRows[i]["id"],
							"custom": selectedcustId,
						});
					}
					var params = {
						billnum: "aa_vendorlist",
						data: JSON.stringify(datas)
					}
					proxy.ensure(params, function(err, result) {
						if(err) {
							cb.utils.alert(err.message, 'error');
							return;
						}
						debugger
						if(result) {
							var count = result.count;
							var sucessCount = result.sucessCount;
							var failCount = result.failCount;
							if(result.messages.length > 0) {
								var messages = result.messages;
								var vendors = '';
								var length = messages.length;
								for(var i = 0; i < length; i++) {
									vendors += messages[i];
									vendors += "、";
								}
								var vendors2 = vendors.substring(0, vendors.length -1);
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。 ' + vendors2 + '已分配此客户，此次操作未对其生效！', 'warning');
							} else {
								cb.utils.alert('共' + count + '条，成功' + sucessCount + '条。', 'success');
							}

						}
						viewmodel.execute('refresh');
					});
				}
			});
    },
	checkorg:function(viewmodel,args){
			var gridData = viewmodel.getGridModel().getData();
			var orgid = gridData[args.params.params.index].org;
			var userOrgs = cb.rest.AppContext.user.userOrgs;
			var findOrg=false;
			if (userOrgs)
			{
				userOrgs.forEach(function (item, index) {
					if (item.org==orgid)
					{
						findOrg=true;
					}
				});
			}
			var custid = gridData[args.params.params.index].cust;
			var usercust = cb.rest.AppContext.user.customer;
			var findCust=false;
			if (usercust)
			{
				if (usercust==custid)
				{
					findCust=true;
				}
			}
			else
			{
				findCust=true;
			}
			if (findOrg==false || findCust==false) 
			{
				cb.utils.alert('没有权限对供应商进行此操作，请检查！', 'warning');
				return false;
			}
			else
			{return true;}
		}
  };

  try {
    module.exports = AA_aa_userlist_VM_Extend;
  } catch (error) {

  }
  return AA_aa_userlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_vendorlist_VM.Extend.js